import { RootState } from "../../store";
import { IntegrationsSliceInterface } from "../integrationsSlice";

export const integrationsStateSelector = (
  state: RootState,
): IntegrationsSliceInterface => {
  return state.integrations;
};
